'use strict';

import animations from 'tc-neos-animations';

const init = () => {
    animations.init()
}

export default {init}
